module.exports = __webpack_public_path__ + "static/media/search.978d2bc5.gif";